const booleanOrValue = (value) =>
  value === 'true' || value === 'false' ? value === 'true' : value;

export const getEnvVar = (name, defaultValue = '') =>
  window._env_?.[name] ? booleanOrValue(window._env_?.[name]) : defaultValue;

export const getSupportEmail = () => getEnvVar('REACT_APP_SUPPORT_EMAIL', 'support@valideval.com');

export const linkedinParamSeparator = '____VE____';

export const isGovEnv = () => getEnvVar('REACT_APP_GOV_ENV') === '1';
